export { LargeHeading } from './large-heading';
